<template>
    <j-modal
      title="安排考试"
      :width="width"
      :visible="visible"
      switchFullscreen
      @ok="handleOk"
      :okButtonProps="{ class:{'jee-hidden': disableSubmit} }"
      @cancel="handleCancel"
      cancelText="关闭">
      <teaching-paper-dept-form ref="realForm" @ok="submitCallback" :disabled="disableSubmit"></teaching-paper-dept-form>
    </j-modal>
  </template>
  
  <script>
  
    import TeachingPaperDeptForm from './TeachingPaperDeptForm'
    export default {
      name: 'TeachingPaperDeptModal',
      components: {
        TeachingPaperDeptForm
      },
      data () {
        return {
          width:800,
          visible: false,
          disableSubmit: false
        }
      },
      methods: {
        add () {
          this.visible=true
          this.$nextTick(()=>{
            this.$refs.realForm.add();
          })
        },
        edit (record) {
          this.visible=true
          this.$nextTick(()=>{
            this.$refs.realForm.edit(record);
          })
        },
        close () {
          this.$emit('close');
          this.visible = false;
        },
        handleOk () {
          this.$refs.realForm.submitForm();
        },
        submitCallback(){
          this.$emit('ok');
          this.visible = false;
        },
        handleCancel () {
          this.close()
        }
      }
    }
  </script>